export default "__VITE_ASSET__ci299BFu__"